import { SFTP_AUTHENTICATION_MODE } from './managedAccount.constants';

const emptyForm = {
  host: '',
  port: '22',
  username: '',
  authentication_mode: SFTP_AUTHENTICATION_MODE.PASSWORD,
  password: '',
  private_key: '',
  public_key: '',
  outbound_path: '',
  positive_pay_prefix: '',
  header_account: '',
  should_encrypt: false,
  pgp_public_key: '',
};

export const toPositivePayForm = (configuration) => {
  if (!configuration) {
    return emptyForm;
  }

  return {
    host: configuration.host,
    port: String(configuration.port),
    username: configuration.username,
    authentication_mode: configuration.authenticationMode,
    password: '',
    private_key: '',
    public_key: configuration.publicKey ?? '',
    outbound_path: configuration.outboundPath ?? '',
    positive_pay_prefix: configuration.positivePayPrefix ?? '',
    header_account: '',
    should_encrypt: configuration.shouldEncrypt ?? false,
    pgp_public_key: configuration.pgpPublicKey ?? '',
  };
};
